import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { InsideLookSection } from '../components/InsideLookSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-273" data-mp="lnh0fr8hyzgv">
      <HeroSection data-id="element-274" data-mp="2zjyjnl7mm2h8" />
      <ProofSection data-id="element-275" data-mp="2zki1z316usvs" />
      <ProblemSection data-id="element-276" data-mp="2zgu9m77hccin" />
      <SystemSection data-id="element-277" data-mp="33k90xu0vcfbe" />
      <ModulesSection data-id="element-278" data-mp="33jqxacbvmytg" />
      <InsideLookSection data-id="element-279" data-mp="33lbnxqv2lxm1" />
      <BonusSection data-id="element-280" data-mp="33ifuaeq99v3e" />
      <UrgencySection data-id="element-281" data-mp="38jve63gp5vk7" />
      <PricingSection data-id="element-282" data-mp="38jd70bshxwxi" />
      <TestimonialsSection data-id="element-283" data-mp="38i25kimix19k" />
      <GuaranteeSection data-id="element-284" data-mp="38hse0qltym1r" />
      <FAQSection data-id="element-285" data-mp="3da22e27are1x" />
      <FinalCTA data-id="element-286" data-mp="3dallvncliai2" />
      <Footer data-id="element-287" data-mp="3db3nkzi11gxd" />
      <PurchasePopup data-id="element-288" data-mp="3dbmw5plsesyq" />
    </main>;
}